import { components, ControlProps } from 'react-select';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';

export function CustomControl<IsMulti extends boolean>(props: ControlProps<ModelEntitySearchResponseItem, IsMulti>) {
  return <components.Control {...props}>{props.children}</components.Control>;
}
